/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/date/datepb.dateadapter.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Inject, Injectable, Optional } from "@angular/core";
import { DateAdapter, MAT_DATE_LOCALE } from "@angular/material/core";
import { fromDate, toDate } from "./datepb.pipe";
import * as i0 from "@angular/core";
/**
 * Adapts Dates for use with Angular Material.
 */
export class DatePbAdapter extends DateAdapter {
    /**
     * @param {?} dateLocale
     */
    constructor(dateLocale) {
        super();
        this.setLocale(dateLocale);
    }
    /**
     * @param {?} locale
     * @return {?}
     */
    setLocale(locale) { super.setLocale(locale); }
    /**
     * @param {?} date
     * @return {?}
     */
    getYear(date) { return date.year; }
    /**
     * @param {?} date
     * @return {?}
     */
    getMonth(date) { return date.month; }
    /**
     * @param {?} date
     * @return {?}
     */
    getDate(date) { return date.day; }
    /**
     * @param {?} date
     * @return {?}
     */
    getDayOfWeek(date) { return toDate(date).getDay(); }
    /**
     * @param {?} style
     * @return {?}
     */
    getMonthNames(style) {
        switch (style) {
            case "short":
            case "narrow":
            case "long":
                return [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec",
                ];
        }
    }
    /**
     * @return {?}
     */
    getDateNames() {
        // The numbers to show associated with each numeric date.
        return Array(31).fill(1).map((/**
         * @param {?} v
         * @param {?} i
         * @return {?}
         */
        (v, i) => `${i + 1}`));
    }
    /**
     * @param {?} style
     * @return {?}
     */
    getDayOfWeekNames(style) {
        switch (style) {
            case "long":
                return [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                    "Sunday",
                ];
            case "short":
            case "narrow":
                return [
                    "Mo",
                    "Tu",
                    "We",
                    "Th",
                    "Fr",
                    "Sa",
                    "Su",
                ];
        }
    }
    /**
     * @param {?} date
     * @return {?}
     */
    getYearName(date) { return `${date.year}`; }
    /**
     * @return {?}
     */
    getFirstDayOfWeek() {
        // 0 is Sunday.
        return 0;
    }
    /**
     * @param {?} date
     * @return {?}
     */
    getNumDaysInMonth(date) {
        return new Date(date.year, date.month - 1, 0).getDate();
    }
    /**
     * @param {?} year
     * @param {?} month
     * @param {?} date
     * @return {?}
     */
    createDate(year, month, date) {
        return { year, month, day: date };
    }
    /**
     * @return {?}
     */
    today() {
        /** @type {?} */
        const now = new Date();
        return {
            year: now.getFullYear(),
            month: now.getMonth() + 1,
            day: now.getDate(),
        };
    }
    /**
     * @param {?} value
     * @param {?} parseFormat
     * @return {?}
     */
    parse(value, parseFormat) {
        /** @type {?} */
        const d = new Date(value);
        return fromDate(d);
    }
    /**
     * @param {?} date
     * @param {?} displayFormat
     * @return {?}
     */
    format(date, displayFormat) {
        /** @type {?} */
        const d = toDate(date);
        return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
    }
    /**
     * @param {?} date
     * @param {?} years
     * @return {?}
     */
    addCalendarYears(date, years) {
        throw new Error("Not yet implemented");
        // return this.clone(date).add({years});
    }
    /**
     * @param {?} date
     * @param {?} months
     * @return {?}
     */
    addCalendarMonths(date, months) {
        throw new Error("Not yet implemented");
        // return this.clone(date).add({months});
    }
    /**
     * @param {?} date
     * @param {?} days
     * @return {?}
     */
    addCalendarDays(date, days) {
        throw new Error("Not yet implemented");
        // return this.clone(date).add({days});
    }
    /**
     * @param {?} date
     * @return {?}
     */
    toIso8601(date) {
        throw new Error("Not yet implemented");
        // return this.clone(date).format();
    }
    /**
     * Returns the given value if given a valid Moment or null. Deserializes valid
     * ISO 8601 strings (https://www.ietf.org/rfc/rfc3339.txt) and valid Date
     * objects into valid Moments and empty string into null. Returns an invalid
     * date for all other values.
     * @param {?} value
     * @return {?}
     */
    deserialize(value) {
        if (this.isValid(value)) {
            return value;
        }
        super.deserialize(value);
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    isDateInstance(obj) {
        // typeof null == object... because reasons.
        return obj != null && typeof obj == "object" && obj.year && obj.month &&
            obj.day;
    }
    /**
     * @param {?} date
     * @return {?}
     */
    isValid(date) { return this.isDateInstance(date); }
    /**
     * @return {?}
     */
    invalid() { return { year: 1, month: 1, day: 1 }; }
    /**
     * @param {?} date
     * @return {?}
     */
    clone(date) {
        return {
            year: date.year,
            month: date.month,
            day: date.day,
        };
    }
}
DatePbAdapter.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DatePbAdapter.ctorParameters = () => [
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [MAT_DATE_LOCALE,] }] }
];
/** @nocollapse */ DatePbAdapter.ɵfac = function DatePbAdapter_Factory(t) { return new (t || DatePbAdapter)(i0.ɵɵinject(MAT_DATE_LOCALE, 8)); };
/** @nocollapse */ DatePbAdapter.ɵprov = i0.ɵɵdefineInjectable({ token: DatePbAdapter, factory: DatePbAdapter.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(DatePbAdapter, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MAT_DATE_LOCALE]
            }] }]; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZXBiLmRhdGVhZGFwdGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vdmlzaW9uaWNzL25nL3NyYy9hcHAvZGF0ZS9kYXRlcGIuZGF0ZWFkYXB0ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxPQUFPLEVBQUMsTUFBTSxFQUFFLFVBQVUsRUFBa0IsUUFBUSxFQUFDLE1BQU0sZUFBZSxDQUFDO0FBQzNFLE9BQU8sRUFBQyxXQUFXLEVBQUUsZUFBZSxFQUFDLE1BQU0sd0JBQXdCLENBQUM7QUFHcEUsT0FBTyxFQUFDLFFBQVEsRUFBRSxNQUFNLEVBQUMsTUFBTSxlQUFlLENBQUM7Ozs7O0FBSS9DLE1BQU0sT0FBTyxhQUFjLFNBQVEsV0FBb0I7Ozs7SUFFckQsWUFDeUMsVUFBa0I7UUFFekQsS0FBSyxFQUFFLENBQUM7UUFDUixJQUFJLENBQUMsU0FBUyxDQUFDLFVBQVUsQ0FBQyxDQUFDO0lBQzdCLENBQUM7Ozs7O0lBRUQsU0FBUyxDQUFDLE1BQWMsSUFBSSxLQUFLLENBQUMsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQzs7Ozs7SUFFdEQsT0FBTyxDQUFDLElBQWEsSUFBWSxPQUFPLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDOzs7OztJQUVwRCxRQUFRLENBQUMsSUFBYSxJQUFZLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7Ozs7O0lBRXRELE9BQU8sQ0FBQyxJQUFhLElBQVksT0FBTyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQzs7Ozs7SUFFbkQsWUFBWSxDQUFDLElBQWEsSUFBWSxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxDQUFDLENBQUM7Ozs7O0lBRXJFLGFBQWEsQ0FBQyxLQUE4QjtRQUMxQyxRQUFRLEtBQUssRUFBRTtZQUNmLEtBQUssT0FBTyxDQUFDO1lBQ2IsS0FBSyxRQUFRLENBQUM7WUFDZCxLQUFLLE1BQU07Z0JBQ1QsT0FBTztvQkFDTCxLQUFLO29CQUNMLEtBQUs7b0JBQ0wsS0FBSztvQkFDTCxLQUFLO29CQUNMLEtBQUs7b0JBQ0wsS0FBSztvQkFDTCxLQUFLO29CQUNMLEtBQUs7b0JBQ0wsS0FBSztvQkFDTCxLQUFLO29CQUNMLEtBQUs7b0JBQ0wsS0FBSztpQkFDTixDQUFDO1NBQ0g7SUFDSCxDQUFDOzs7O0lBRUQsWUFBWTtRQUNWLHlEQUF5RDtRQUN6RCxPQUFPLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRzs7Ozs7UUFBQyxDQUFDLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRSxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsRUFBRSxFQUFDLENBQUM7SUFDckQsQ0FBQzs7Ozs7SUFFRCxpQkFBaUIsQ0FBQyxLQUE4QjtRQUM5QyxRQUFRLEtBQUssRUFBRTtZQUNmLEtBQUssTUFBTTtnQkFDVCxPQUFPO29CQUNMLFFBQVE7b0JBQ1IsU0FBUztvQkFDVCxXQUFXO29CQUNYLFVBQVU7b0JBQ1YsUUFBUTtvQkFDUixVQUFVO29CQUNWLFFBQVE7aUJBQ1QsQ0FBQztZQUNKLEtBQUssT0FBTyxDQUFDO1lBQ2IsS0FBSyxRQUFRO2dCQUNYLE9BQU87b0JBQ0wsSUFBSTtvQkFDSixJQUFJO29CQUNKLElBQUk7b0JBQ0osSUFBSTtvQkFDSixJQUFJO29CQUNKLElBQUk7b0JBQ0osSUFBSTtpQkFDTCxDQUFDO1NBQ0g7SUFDSCxDQUFDOzs7OztJQUVELFdBQVcsQ0FBQyxJQUFhLElBQVksT0FBTyxHQUFHLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUFDLENBQUM7Ozs7SUFFN0QsaUJBQWlCO1FBQ2YsZUFBZTtRQUNmLE9BQU8sQ0FBQyxDQUFDO0lBQ1gsQ0FBQzs7Ozs7SUFFRCxpQkFBaUIsQ0FBQyxJQUFhO1FBQzdCLE9BQU8sSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsS0FBSyxHQUFHLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxPQUFPLEVBQUUsQ0FBQztJQUMxRCxDQUFDOzs7Ozs7O0lBRUQsVUFBVSxDQUFDLElBQVksRUFBRSxLQUFhLEVBQUUsSUFBWTtRQUNsRCxPQUFPLEVBQUMsSUFBSSxFQUFFLEtBQUssRUFBRSxHQUFHLEVBQUcsSUFBSSxFQUFDLENBQUM7SUFDbkMsQ0FBQzs7OztJQUVELEtBQUs7O2NBQ0csR0FBRyxHQUFHLElBQUksSUFBSSxFQUFFO1FBQ3RCLE9BQU87WUFDTCxJQUFJLEVBQUcsR0FBRyxDQUFDLFdBQVcsRUFBRTtZQUN4QixLQUFLLEVBQUcsR0FBRyxDQUFDLFFBQVEsRUFBRSxHQUFHLENBQUM7WUFDMUIsR0FBRyxFQUFHLEdBQUcsQ0FBQyxPQUFPLEVBQUU7U0FDcEIsQ0FBQztJQUNKLENBQUM7Ozs7OztJQUVELEtBQUssQ0FBQyxLQUFVLEVBQUUsV0FBNEI7O2NBQ3RDLENBQUMsR0FBRyxJQUFJLElBQUksQ0FBQyxLQUFLLENBQUM7UUFDekIsT0FBTyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDckIsQ0FBQzs7Ozs7O0lBRUQsTUFBTSxDQUFDLElBQWEsRUFBRSxhQUFxQjs7Y0FDbkMsQ0FBQyxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUM7UUFDdEIsT0FBTyxHQUFHLENBQUMsQ0FBQyxXQUFXLEVBQUUsSUFBSSxDQUFDLENBQUMsUUFBUSxFQUFFLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQyxPQUFPLEVBQUUsRUFBRSxDQUFDO0lBQ2pFLENBQUM7Ozs7OztJQUVELGdCQUFnQixDQUFDLElBQWEsRUFBRSxLQUFhO1FBQzNDLE1BQU0sSUFBSSxLQUFLLENBQUMscUJBQXFCLENBQUMsQ0FBQztRQUN2Qyx3Q0FBd0M7SUFDMUMsQ0FBQzs7Ozs7O0lBRUQsaUJBQWlCLENBQUMsSUFBYSxFQUFFLE1BQWM7UUFDN0MsTUFBTSxJQUFJLEtBQUssQ0FBQyxxQkFBcUIsQ0FBQyxDQUFDO1FBQ3ZDLHlDQUF5QztJQUMzQyxDQUFDOzs7Ozs7SUFFRCxlQUFlLENBQUMsSUFBYSxFQUFFLElBQVk7UUFDekMsTUFBTSxJQUFJLEtBQUssQ0FBQyxxQkFBcUIsQ0FBQyxDQUFDO1FBQ3ZDLHVDQUF1QztJQUN6QyxDQUFDOzs7OztJQUVELFNBQVMsQ0FBQyxJQUFhO1FBQ3JCLE1BQU0sSUFBSSxLQUFLLENBQUMscUJBQXFCLENBQUMsQ0FBQztRQUN2QyxvQ0FBb0M7SUFDdEMsQ0FBQzs7Ozs7Ozs7O0lBUUQsV0FBVyxDQUFDLEtBQVU7UUFDcEIsSUFBSSxJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxFQUFFO1lBQ3ZCLE9BQU8sS0FBSyxDQUFDO1NBQ2Q7UUFDRCxLQUFLLENBQUMsV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQzNCLENBQUM7Ozs7O0lBRUQsY0FBYyxDQUFDLEdBQVE7UUFDckIsNENBQTRDO1FBQzVDLE9BQU8sR0FBRyxJQUFJLElBQUksSUFBSSxPQUFPLEdBQUcsSUFBSSxRQUFRLElBQUksR0FBRyxDQUFDLElBQUksSUFBSSxHQUFHLENBQUMsS0FBSztZQUM5RCxHQUFHLENBQUMsR0FBRyxDQUFDO0lBQ2pCLENBQUM7Ozs7O0lBRUQsT0FBTyxDQUFDLElBQWEsSUFBYSxPQUFPLElBQUksQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDOzs7O0lBQ3JFLE9BQU8sS0FBYyxPQUFPLEVBQUMsSUFBSSxFQUFHLENBQUMsRUFBRSxLQUFLLEVBQUcsQ0FBQyxFQUFFLEdBQUcsRUFBRyxDQUFDLEVBQUMsQ0FBQyxDQUFDLENBQUM7Ozs7O0lBRTdELEtBQUssQ0FBQyxJQUFhO1FBQ2pCLE9BQU87WUFDTCxJQUFJLEVBQUcsSUFBSSxDQUFDLElBQUk7WUFDaEIsS0FBSyxFQUFHLElBQUksQ0FBQyxLQUFLO1lBQ2xCLEdBQUcsRUFBRyxJQUFJLENBQUMsR0FBRztTQUNmLENBQUM7SUFDSixDQUFDOzs7WUEzSkYsVUFBVTs7Ozt5Q0FJSixRQUFRLFlBQUksTUFBTSxTQUFDLGVBQWU7OzBFQUg1QixhQUFhLGNBR0EsZUFBZTtxREFINUIsYUFBYSxXQUFiLGFBQWE7a0RBQWIsYUFBYTtjQUR6QixVQUFVOztzQkFJSixRQUFROztzQkFBSSxNQUFNO3VCQUFDLGVBQWUiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge0luamVjdCwgSW5qZWN0YWJsZSwgSW5qZWN0aW9uVG9rZW4sIE9wdGlvbmFsfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtEYXRlQWRhcHRlciwgTUFUX0RBVEVfTE9DQUxFfSBmcm9tIFwiQGFuZ3VsYXIvbWF0ZXJpYWwvY29yZVwiO1xuXG5pbXBvcnQge0FwaURhdGV9IGZyb20gXCJ2aWNzL3Zpc2lvbmljcy9hcGkvbmcvaW5kZXhcIjtcbmltcG9ydCB7ZnJvbURhdGUsIHRvRGF0ZX0gZnJvbSBcIi4vZGF0ZXBiLnBpcGVcIjtcblxuLyoqIEFkYXB0cyBEYXRlcyBmb3IgdXNlIHdpdGggQW5ndWxhciBNYXRlcmlhbC4gKi9cbkBJbmplY3RhYmxlKClcbmV4cG9ydCBjbGFzcyBEYXRlUGJBZGFwdGVyIGV4dGVuZHMgRGF0ZUFkYXB0ZXI8QXBpRGF0ZT4ge1xuXG4gIGNvbnN0cnVjdG9yKFxuICAgICAgQE9wdGlvbmFsKCkgQEluamVjdChNQVRfREFURV9MT0NBTEUpIGRhdGVMb2NhbGU6IHN0cmluZyxcbiAgKSB7XG4gICAgc3VwZXIoKTtcbiAgICB0aGlzLnNldExvY2FsZShkYXRlTG9jYWxlKTtcbiAgfVxuXG4gIHNldExvY2FsZShsb2NhbGU6IHN0cmluZykgeyBzdXBlci5zZXRMb2NhbGUobG9jYWxlKTsgfVxuXG4gIGdldFllYXIoZGF0ZTogQXBpRGF0ZSk6IG51bWJlciB7IHJldHVybiBkYXRlLnllYXI7IH1cblxuICBnZXRNb250aChkYXRlOiBBcGlEYXRlKTogbnVtYmVyIHsgcmV0dXJuIGRhdGUubW9udGg7IH1cblxuICBnZXREYXRlKGRhdGU6IEFwaURhdGUpOiBudW1iZXIgeyByZXR1cm4gZGF0ZS5kYXk7IH1cblxuICBnZXREYXlPZldlZWsoZGF0ZTogQXBpRGF0ZSk6IG51bWJlciB7IHJldHVybiB0b0RhdGUoZGF0ZSkuZ2V0RGF5KCk7IH1cblxuICBnZXRNb250aE5hbWVzKHN0eWxlOiBcImxvbmdcInxcInNob3J0XCJ8XCJuYXJyb3dcIik6IHN0cmluZ1tdIHtcbiAgICBzd2l0Y2ggKHN0eWxlKSB7XG4gICAgY2FzZSBcInNob3J0XCI6XG4gICAgY2FzZSBcIm5hcnJvd1wiOlxuICAgIGNhc2UgXCJsb25nXCI6XG4gICAgICByZXR1cm4gW1xuICAgICAgICBcIkphblwiLFxuICAgICAgICBcIkZlYlwiLFxuICAgICAgICBcIk1hclwiLFxuICAgICAgICBcIkFwclwiLFxuICAgICAgICBcIk1heVwiLFxuICAgICAgICBcIkp1blwiLFxuICAgICAgICBcIkp1bFwiLFxuICAgICAgICBcIkF1Z1wiLFxuICAgICAgICBcIlNlcFwiLFxuICAgICAgICBcIk9jdFwiLFxuICAgICAgICBcIk5vdlwiLFxuICAgICAgICBcIkRlY1wiLFxuICAgICAgXTtcbiAgICB9XG4gIH1cblxuICBnZXREYXRlTmFtZXMoKTogc3RyaW5nW10ge1xuICAgIC8vIFRoZSBudW1iZXJzIHRvIHNob3cgYXNzb2NpYXRlZCB3aXRoIGVhY2ggbnVtZXJpYyBkYXRlLlxuICAgIHJldHVybiBBcnJheSgzMSkuZmlsbCgxKS5tYXAoKHYsIGkpID0+IGAke2kgKyAxfWApO1xuICB9XG5cbiAgZ2V0RGF5T2ZXZWVrTmFtZXMoc3R5bGU6IFwibG9uZ1wifFwic2hvcnRcInxcIm5hcnJvd1wiKTogc3RyaW5nW10ge1xuICAgIHN3aXRjaCAoc3R5bGUpIHtcbiAgICBjYXNlIFwibG9uZ1wiOlxuICAgICAgcmV0dXJuIFtcbiAgICAgICAgXCJNb25kYXlcIixcbiAgICAgICAgXCJUdWVzZGF5XCIsXG4gICAgICAgIFwiV2VkbmVzZGF5XCIsXG4gICAgICAgIFwiVGh1cnNkYXlcIixcbiAgICAgICAgXCJGcmlkYXlcIixcbiAgICAgICAgXCJTYXR1cmRheVwiLFxuICAgICAgICBcIlN1bmRheVwiLFxuICAgICAgXTtcbiAgICBjYXNlIFwic2hvcnRcIjpcbiAgICBjYXNlIFwibmFycm93XCI6XG4gICAgICByZXR1cm4gW1xuICAgICAgICBcIk1vXCIsXG4gICAgICAgIFwiVHVcIixcbiAgICAgICAgXCJXZVwiLFxuICAgICAgICBcIlRoXCIsXG4gICAgICAgIFwiRnJcIixcbiAgICAgICAgXCJTYVwiLFxuICAgICAgICBcIlN1XCIsXG4gICAgICBdO1xuICAgIH1cbiAgfVxuXG4gIGdldFllYXJOYW1lKGRhdGU6IEFwaURhdGUpOiBzdHJpbmcgeyByZXR1cm4gYCR7ZGF0ZS55ZWFyfWA7IH1cblxuICBnZXRGaXJzdERheU9mV2VlaygpOiBudW1iZXIge1xuICAgIC8vIDAgaXMgU3VuZGF5LlxuICAgIHJldHVybiAwO1xuICB9XG5cbiAgZ2V0TnVtRGF5c0luTW9udGgoZGF0ZTogQXBpRGF0ZSk6IG51bWJlciB7XG4gICAgcmV0dXJuIG5ldyBEYXRlKGRhdGUueWVhciwgZGF0ZS5tb250aCAtIDEsIDApLmdldERhdGUoKTtcbiAgfVxuXG4gIGNyZWF0ZURhdGUoeWVhcjogbnVtYmVyLCBtb250aDogbnVtYmVyLCBkYXRlOiBudW1iZXIpOiBBcGlEYXRlIHtcbiAgICByZXR1cm4ge3llYXIsIG1vbnRoLCBkYXkgOiBkYXRlfTtcbiAgfVxuXG4gIHRvZGF5KCk6IEFwaURhdGUge1xuICAgIGNvbnN0IG5vdyA9IG5ldyBEYXRlKCk7XG4gICAgcmV0dXJuIHtcbiAgICAgIHllYXIgOiBub3cuZ2V0RnVsbFllYXIoKSxcbiAgICAgIG1vbnRoIDogbm93LmdldE1vbnRoKCkgKyAxLFxuICAgICAgZGF5IDogbm93LmdldERhdGUoKSxcbiAgICB9O1xuICB9XG5cbiAgcGFyc2UodmFsdWU6IGFueSwgcGFyc2VGb3JtYXQ6IHN0cmluZ3xzdHJpbmdbXSk6IEFwaURhdGV8bnVsbCB7XG4gICAgY29uc3QgZCA9IG5ldyBEYXRlKHZhbHVlKTtcbiAgICByZXR1cm4gZnJvbURhdGUoZCk7XG4gIH1cblxuICBmb3JtYXQoZGF0ZTogQXBpRGF0ZSwgZGlzcGxheUZvcm1hdDogc3RyaW5nKTogc3RyaW5nIHtcbiAgICBjb25zdCBkID0gdG9EYXRlKGRhdGUpO1xuICAgIHJldHVybiBgJHtkLmdldEZ1bGxZZWFyKCl9LSR7ZC5nZXRNb250aCgpICsgMX0tJHtkLmdldERhdGUoKX1gO1xuICB9XG5cbiAgYWRkQ2FsZW5kYXJZZWFycyhkYXRlOiBBcGlEYXRlLCB5ZWFyczogbnVtYmVyKTogQXBpRGF0ZSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKFwiTm90IHlldCBpbXBsZW1lbnRlZFwiKTtcbiAgICAvLyByZXR1cm4gdGhpcy5jbG9uZShkYXRlKS5hZGQoe3llYXJzfSk7XG4gIH1cblxuICBhZGRDYWxlbmRhck1vbnRocyhkYXRlOiBBcGlEYXRlLCBtb250aHM6IG51bWJlcik6IEFwaURhdGUge1xuICAgIHRocm93IG5ldyBFcnJvcihcIk5vdCB5ZXQgaW1wbGVtZW50ZWRcIik7XG4gICAgLy8gcmV0dXJuIHRoaXMuY2xvbmUoZGF0ZSkuYWRkKHttb250aHN9KTtcbiAgfVxuXG4gIGFkZENhbGVuZGFyRGF5cyhkYXRlOiBBcGlEYXRlLCBkYXlzOiBudW1iZXIpOiBBcGlEYXRlIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoXCJOb3QgeWV0IGltcGxlbWVudGVkXCIpO1xuICAgIC8vIHJldHVybiB0aGlzLmNsb25lKGRhdGUpLmFkZCh7ZGF5c30pO1xuICB9XG5cbiAgdG9Jc284NjAxKGRhdGU6IEFwaURhdGUpOiBzdHJpbmcge1xuICAgIHRocm93IG5ldyBFcnJvcihcIk5vdCB5ZXQgaW1wbGVtZW50ZWRcIik7XG4gICAgLy8gcmV0dXJuIHRoaXMuY2xvbmUoZGF0ZSkuZm9ybWF0KCk7XG4gIH1cblxuICAvKipcbiAgICogUmV0dXJucyB0aGUgZ2l2ZW4gdmFsdWUgaWYgZ2l2ZW4gYSB2YWxpZCBNb21lbnQgb3IgbnVsbC4gRGVzZXJpYWxpemVzIHZhbGlkXG4gICAqIElTTyA4NjAxIHN0cmluZ3MgKGh0dHBzOi8vd3d3LmlldGYub3JnL3JmYy9yZmMzMzM5LnR4dCkgYW5kIHZhbGlkIERhdGVcbiAgICogb2JqZWN0cyBpbnRvIHZhbGlkIE1vbWVudHMgYW5kIGVtcHR5IHN0cmluZyBpbnRvIG51bGwuIFJldHVybnMgYW4gaW52YWxpZFxuICAgKiBkYXRlIGZvciBhbGwgb3RoZXIgdmFsdWVzLlxuICAgKi9cbiAgZGVzZXJpYWxpemUodmFsdWU6IGFueSk6IEFwaURhdGV8bnVsbCB7XG4gICAgaWYgKHRoaXMuaXNWYWxpZCh2YWx1ZSkpIHtcbiAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9XG4gICAgc3VwZXIuZGVzZXJpYWxpemUodmFsdWUpO1xuICB9XG5cbiAgaXNEYXRlSW5zdGFuY2Uob2JqOiBhbnkpOiBib29sZWFuIHtcbiAgICAvLyB0eXBlb2YgbnVsbCA9PSBvYmplY3QuLi4gYmVjYXVzZSByZWFzb25zLlxuICAgIHJldHVybiBvYmogIT0gbnVsbCAmJiB0eXBlb2Ygb2JqID09IFwib2JqZWN0XCIgJiYgb2JqLnllYXIgJiYgb2JqLm1vbnRoICYmXG4gICAgICAgICAgIG9iai5kYXk7XG4gIH1cblxuICBpc1ZhbGlkKGRhdGU6IEFwaURhdGUpOiBib29sZWFuIHsgcmV0dXJuIHRoaXMuaXNEYXRlSW5zdGFuY2UoZGF0ZSk7IH1cbiAgaW52YWxpZCgpOiBBcGlEYXRlIHsgcmV0dXJuIHt5ZWFyIDogMSwgbW9udGggOiAxLCBkYXkgOiAxfTsgfVxuXG4gIGNsb25lKGRhdGU6IEFwaURhdGUpOiBBcGlEYXRlIHtcbiAgICByZXR1cm4ge1xuICAgICAgeWVhciA6IGRhdGUueWVhcixcbiAgICAgIG1vbnRoIDogZGF0ZS5tb250aCxcbiAgICAgIGRheSA6IGRhdGUuZGF5LFxuICAgIH07XG4gIH1cbn1cbiJdfQ==